<div class="skill-detail">
  <div class="skill-detail__header">
    <div class="skill-detail__header__title">{{ skillDetail?.name }}</div>
  </div>
  <div class="skill-detail__body">
    <div class="skill-detail__body__progress">
      <app-level-progress [levels]="skillDetail?.levels"></app-level-progress>
    </div>
    <div class="skill-detail__body__levels">
      <app-level-card [levels]="skillDetail?.levels" [levelInProgress]="firstLevelInProgress"></app-level-card>
    </div>
  </div>
</div>
